import * as loginService from "./api/login.service";
import LoginThirdPartSettings from "./LoginThirdPartSettings";
import LoginSso from "@/login/thirdpart/LoginSso";

const UnAuthCode = 9999;

function getStraightThirdPartLogin() {
  return LoginThirdPartSettings.straightThirdPartLogin;
}

/**
 * 默认直接跳转第三方登录的地址
 *
 * @returns {string}
 */
function getStraightThirdPartLoginUrl() {
  return LoginThirdPartSettings.defaultThirdPartLoginUrl();
}

function loginTicket(query) {
  if (query && query.logintest) {
    // 非生产环境 绕开竹云单点登录的接口
    return loginService.loginTicket('99', query.logintest, process.env.VUE_APP_CODE, LoginSso.clientId);
  }
  if (query && query.username && query.ticket) {
    // username + ticket 免登录，如 ?username=lvxing@cncec&ticket=-1:xxx
    return loginService.loginTicket('05', query.ticket, process.env.VUE_APP_CODE, LoginSso.clientId, query.username);
  }
  let t = findTicket(query);
  if (!t || !t.ticket) {
    if (query.code) {
      t = {
        userType: LoginSso.userType,
        ticket: query.code,
        clientId: LoginSso.clientId
      };
    } else {
      return Promise.reject({ code: UnAuthCode });
    }
  }
  return loginService.loginTicket(t.userType, t.ticket, process.env.VUE_APP_CODE, t.clientId);
}

function logout(userType = LoginSso.userType) {
  if (LoginThirdPartSettings.loginThirdPartMap[userType]) {
    location.href = LoginThirdPartSettings.loginThirdPartMap[userType].getLogoutUrl();
  }
}

function getUserInfo() {
  return loginService.getInfo();
}

function findTicket(query) {
  if (!query ||!Object.keys(query).length) {
    return null;
  }
  let ticket = null;
  let userType = null;
  let clientId = null;
  for (let i = 0; i < LoginThirdPartSettings.userTypeKeys.length; i++) {
    const userTypeKey = LoginThirdPartSettings.userTypeKeys[i];
    if (query[userTypeKey]) {
      userType = query[userTypeKey];
      const loginInstance = LoginThirdPartSettings.loginThirdPartMap[userType];
      ticket = query[loginInstance.getTicketKey()];
      clientId = loginInstance.clientId;
      delete query[userTypeKey];
      delete query[loginInstance.getTicketKey()];
      break;
    }
  }
  return { userType, ticket, clientId };
}

export default {
  UnAuthCode,
  getStraightThirdPartLogin,
  getStraightThirdPartLoginUrl,
  loginTicket,
  logout,
  getUserInfo
}
